import { useGetDictionaries } from "@synthesis/shared-services/external/dictionaries/hooks";
import { useMemo } from "react";

import {
  buildCreateApplicationDictionaries,
  EMPTY_CREATE_APPLICATION_DICTIONARIES,
  type CreateApplicationDictionaries,
} from "../create-application-dictionaries.lib";

type UseCreateApplicationDictionariesResult = {
  dictionaries: CreateApplicationDictionaries;
  isLoading: boolean;
  isError: boolean;
};

export const useCreateApplicationDictionaries = (): UseCreateApplicationDictionariesResult => {
  const query = useGetDictionaries();

  const dictionaries = useMemo(
    () => (query.data ? buildCreateApplicationDictionaries(query.data) : EMPTY_CREATE_APPLICATION_DICTIONARIES),
    [query.data],
  );

  return {
    dictionaries,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
